import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router';
import { Club } from '@repo/types';
import cn from 'classnames';
import { Image } from '../../../../common/components/Image';

type ClubSwitcherProps = {
  clubs: Club[];
};

export function ClubSwitcher({ clubs }: ClubSwitcherProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);

  const selectedClub = useMemo(
    () =>
      searchParams.get('team')
        ? // @ts-expect-error TODO: fix this type issue
          clubs.find((club) => club.team.id === searchParams.get('team'))
        : clubs.find((club) => club.id === searchParams.get('club')),
    [searchParams, clubs]
  );

  const onOpenDropdown = () => {
    setIsOpen(true);
  };

  const onCloseDropdown = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const onClubSelect = (club: Club) => {
    // @ts-expect-error TODO: fix this type issue
    searchParams.set('team', club.team.id);
    searchParams.delete('competition');
    setSearchParams(searchParams);
  };

  useLayoutEffect(() => {
    document.addEventListener('click', onCloseDropdown);

    return () => {
      document.removeEventListener('click', onCloseDropdown);
    };
  });

  return (
    <div className="team-switcher" ref={ref}>
      <div className="team-switcher__select" onClick={onOpenDropdown}>
        <span className="team-switcher__selected-label">{selectedClub ? selectedClub.fullName : 'ALL CLUBS'}</span>
        <Image className="team-switcher__select-icon" src={'chevron-left.svg'} alt={'expand'} width={24} height={24} />
      </div>
      <ul
        className={cn('team-switcher__options-list', {
          'team-switcher__options-list--open': isOpen,
        })}
      >
        <li
          className="team-switcher__options-list-item"
          data-value={''}
          onClick={() => {
            searchParams.delete('team');
            searchParams.delete('club');
            setSearchParams(searchParams);
          }}
        >
          ALL CLUBS
        </li>
        {clubs.map((club) => (
          <li
            key={club.id}
            className="team-switcher__options-list-item"
            data-value={club.id}
            onClick={() => onClubSelect(club)}
          >
            {club.fullName}
          </li>
        ))}
      </ul>
    </div>
  );
}
